require('./bootstrap');
require('./jquery-ui');
require('jquery-ui-sortable-npm');
//import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';

window.ScrollReveal = require('scrollreveal/dist/scrollreveal.js');